import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  orderList: {
    marginBottom: 0,
  },
}));

const GceInstruction = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <ol className={classes.orderList}>
      <li>
        <Typography variant="body1">
          {t('withdrawal->>Coordinator.Instruction.Content1')}
        </Typography>
        <ul style={{ listStyleType: 'disc' }}>
          <li>
            <Typography variant="body1">
              {t('withdrawal->>Coordinator.Instruction.SubContent1')}
            </Typography>
          </li>
        </ul>
      </li>
      <li>
        <Typography variant="body1">
          {t('withdrawal->>Coordinator.Instruction.Content2')}
        </Typography>
      </li>
      <li>
        <Typography variant="body1">
          {t('withdrawal->>Coordinator.Instruction.Content3')}
        </Typography>
      </li>
      <li>
        <Typography variant="body1">
          {t('withdrawal->>Coordinator.Instruction.Content4')}
        </Typography>
      </li>
      <li>
        <Typography variant="body1">
          {t('withdrawal->>Coordinator.Instruction.Content5')}
        </Typography>
      </li>
    </ol>
  );
};
export default GceInstruction;
